import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import { Menu, X } from "lucide-react";
import "./Navbar.css";
import logo from "../assets/12.PNG";

const NAV_LINKS = [
  { label: "Home", section: "home" },
  { label: "About", section: "about" },
  { label: "Products", section: "products" },
  { label: "Contact", section: "contact" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const scrollToSection = (section) => {
    setMenuOpen(false);

    if (!isHome) {
      navigate("/");
      setTimeout(() => {
        scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 });
      }, 120);
      return;
    }

    scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 });
  };

  const handleLogoClick = (e) => {
    if (isHome) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""} ${!isHome ? "dark-page" : ""}`}>
      <Link to="/" className="navbar-logo" onClick={handleLogoClick}>
        <img src={logo} alt="Demollari E.E.E" />
      </Link>

      <button
        type="button"
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen((open) => !open)}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
      >
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
        {NAV_LINKS.map((link) => (
          <li key={link.section}>
            <button type="button" onClick={() => scrollToSection(link.section)}>
              {link.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
